import React from 'react';
import Link from 'next/link';
import { useDispatch, useSelector } from 'react-redux';
import { useRouter } from 'next/router';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

import { closeModal } from 'features/utilsSlice';
import useModalOpen from 'hooks/useModalOpen';
import CongratulationsImage from 'public/images/congratulations.svg';
import TransitionDialog from 'components/TransitionDialog';
import styles from 'styles/components/Congratulations.module.scss';

const useStyles = makeStyles(theme => ({
  paper: {
    width: '95%',
    height: 'auto',
    borderRadius: 10,
    backgroundColor: '#f5f0ff',
  },

  paperFullWidth: {
    [theme.breakpoints.up('sm')]: {
      width: '50%',
      margin: '0 auto',
    },

    [theme.breakpoints.up('lg')]: {
      width: '35%',
    },

    [theme.breakpoints.up('xl')]: {
      width: '30%',
    },
  },
}));

const AcceptedGigDialog = ({ gig }) => {
  const open = useModalOpen('Accepted Gig');
  const dispatch = useDispatch();
  const classes = useStyles();
  const router = useRouter();

  const { invitation } = useSelector(state => state.utils.modalData['Accepted Gig']);

  const handleClose = () => {
    if (gig.multiple_hires) {
      router.push(`/gigs/${invitation.gig_id}`);
    } else {
      router.reload();
    }

    dispatch(closeModal('Accepted Gig'));
  };

  const fullWidth = { width: '100%' };

  return (
    <TransitionDialog
      open={open}
      handleClose={handleClose}
      paperProps={{ className: classes.paper }}
      dialogStyles={classes.paperFullWidth}
      desktopDirection="up"
      direction="up"
      noCloseIcon
    >
      <div className={styles.congratulations}>
        <div className={styles.title}>
          <CongratulationsImage />

          <h3>
            {invitation?.license_only
              ? 'WOOHOO! THE ORDER HAS BEEN ACCEPTED!'
              : 'WOOHOO! YOU GOT THE GIG!'}
          </h3>

          {!invitation?.license_only && (
            <p style={{ margin: '30px 0' }}>
              {gig.funded ? (
                <>
                  You are ready to get started posting your ToDo's for{' '}
                  <strong>{gig.user.display_name}</strong>
                </>
              ) : (
                <>
                  We are just waiting for this gig to be funded before you can start posting your
                  ToDo's. <br />
                  <br /> We will send you a notification when{' '}
                  <strong>{gig.user.display_name}</strong> finalizes the payment.
                </>
              )}
            </p>
          )}
        </div>

        <div className={styles.buttons} style={invitation?.license_only ? { marginTop: 30 } : {}}>
          <Link href={`/gigs/${gig.id}?tab=todos`} passHref>
            <Button
              onClick={handleClose}
              variant="contained"
              color="primary"
              style={fullWidth}
              fullWidth
            >
              {gig.funded && !invitation?.license_only ? "Let's post now!" : 'Ok, cool!'}
            </Button>
          </Link>

          {gig.funded && !invitation?.license_only && (
            <Link href={`/gigs/${gig.id}`} passHref>
              <Button
                onClick={handleClose}
                variant="outlined"
                color="primary"
                style={fullWidth}
                fullWidth
              >
                I'll do it later
              </Button>
            </Link>
          )}
        </div>
      </div>
    </TransitionDialog>
  );
};

export default AcceptedGigDialog;
